document.addEventListener('DOMContentLoaded', function () {
  if (window.screen.width < 800) {
    // *.*.*.*.*.*.*.*.*.*.* START OF MENU *.*.*.*.*.*.*.*.*.*.* 
    var menu = document.querySelector('.main_header .menu_icon');
    var closeButton = document.querySelector('.close_menu');
    var menuModal = document.querySelector('.main_header .menu_modal');

    menu.addEventListener('click', toggleMenu);
    closeButton.addEventListener('click', closeMenu);
    menuModal.addEventListener('click', function (event) {
      if (!event.target.closest('.nav_toggle')) {
        closeMenu();
      }
    });

    function toggleMenu() {
      if (menuModal.classList.contains('show_menu')) {
        closeMenu();
      } else {
        menuModal.classList.add('show_menu');
        closeButton.classList.remove('hidden_button');
      }
    }

    function closeMenu() {
      menuModal.classList.remove('show_menu');
      closeButton.classList.add('hidden_button');
    }
    // *.*.*.*.*.*.*.*.*.*.* END OF MENU *.*.*.*.*.*.*.*.*.*.*
    // *.*.*.*.*.*.*.*.*.*.* SUB_MENU *.*.*.*.*.*.*.*.*.*.*
    var menuButtons = document.querySelectorAll('.sub_menu_btn');
    menuButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var subMenu = btn.nextElementSibling;
        if (subMenu) {
          subMenu.classList.toggle('sub_menu_show');

          if (subMenu.classList.contains('sub_menu_show')) {
            btn.style.transform = 'rotate(0)';
            btn.style.top = '-3px';
          } else {
            btn.style.transform = 'rotate(90deg)';
            btn.style.top = '7px';
          }
        }
      });
    });
    // *.*.*.*.*.*.*.*.*.*.* END OF SUB_MENU *.*.*.*.*.*.*.*.*.*.*
  }
  // *.*.*.*.*.*.*.*.*.*.* SEARCH *.*.*.*.*.*.*.*.*.*.*
  document.getElementById("search_icon").addEventListener("click", function () {
    const getSearch = document.getElementById("search_modal");
    const display = window.getComputedStyle(getSearch).visibility;
    if (display === "hidden") {
      getSearch.style.visibility = "visible";
      getSearch.style.opacity = "1";
    } else {
      getSearch.style.visibility = "hidden";
      getSearch.style.opacity = "0";
    }
  });
  // ************* close search ************
  document.getElementById("close_search").addEventListener("click", function () {
    const getSearch = document.getElementById("search_modal");
    const display = window.getComputedStyle(getSearch).visibility;
    if (display === "hidden") {
      getSearch.style.visibility = "visible";
      getSearch.style.opacity = "1";
    } else {
      getSearch.style.visibility = "hidden";
      getSearch.style.opacity = "0";
    }
  });
  var modal = document.getElementById("search_modal");
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.visibility = "hidden";
      modal.style.opacity = "0";
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF SEARCH *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* FRONT_B *.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("front_b")) {
    new Splide("#front_b", {
      perMove: 1,
      perPage: 1,
      type: "loop",
      autoplay: true,
      interval: 4000,
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
    }).mount();
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF FRONT_B *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* FRONT_F & LANDING_C *.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("most_views")) {
    new Splide("#most_views", {
      gap: '1em',
      perMove: 1,
      perPage: 4,
      type: "loop",
      autoplay: true,
      interval: 3500,
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
      breakpoints: {
        700: {
          perPage: 3,
        },
        600: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      }
    }).mount();
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF FRONT_F & LANDING_C *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* FRONT_K & LANDING_H *.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("videos")) {
    new Splide("#videos", {
      gap: '1em',
      perMove: 1,
      perPage: 4,
      type: "loop",
      autoplay: true,
      interval: 3500,
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
      breakpoints: {
        700: {
          perPage: 3,
        },
        600: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      }
    }).mount();
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF FRONT_K & LANDING_H *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* FRONT_J & LANDING_G *.*.*.*.*.*.*.*.*.*.* //
  const players = document.querySelectorAll('.custom_audio_player');
  players.forEach((player) => {
    const audio = player.querySelector('.audioPlayer');
    const playPauseBtn = player.querySelector('.playPauseBtn');
    const progress = player.querySelector('.progress');
    const currentTimeEl = player.querySelector('.currentTime');
    const durationEl = player.querySelector('.duration');
    const backwardBtn = player.querySelector('.backwardBtn');
    const forwardBtn = player.querySelector('.forwardBtn');


    if (!playPauseBtn || !progress || !currentTimeEl || !durationEl || !backwardBtn || !forwardBtn) {
      return;
    }

    const playIcon = playPauseBtn.querySelector('.play');
    const pauseIcon = playPauseBtn.querySelector('.pause');

    if (!playIcon || !pauseIcon) {
      console.error('One or more control icons are missing.');
      return;
    }

    const formatTime = (time) => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    };

    // Check if audio is loaded before starting playback
    audio.addEventListener('canplay', () => {
      durationEl.textContent = formatTime(audio.duration);
    });

    // Update progress bar and time
    audio.addEventListener('timeupdate', () => {
      if (audio.duration > 0) {
        progress.value = (audio.currentTime / audio.duration) * 100 || 0;
        currentTimeEl.textContent = formatTime(audio.currentTime);
      }
    });

    // Play/pause functionality
    playPauseBtn.addEventListener('click', () => {
      if (audio.paused) {
        audio.play();
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
      } else {
        audio.pause();
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
      }
    });

    // Seek functionality
    progress.addEventListener('input', () => {
      audio.currentTime = (progress.value / 100) * audio.duration;
    });

    // Skip backward and forward
    backwardBtn.addEventListener('click', () => {
      audio.currentTime = Math.max(0, audio.currentTime - 10); // Skip 10 seconds backward
    });

    forwardBtn.addEventListener('click', () => {
      audio.currentTime = Math.min(audio.duration, audio.currentTime + 10); // Skip 10 seconds forward
    });
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF FRONT_J & LANDING_G *.*.*.*.*.*.*.*.*.*.* //
  // *.*.*.*.*.*.*.*.*.*.* ARCHIVE ICON *.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".archive_news_type .flip")) {
    var archive = document.querySelector(".archive_news_type .flip");
    archive.addEventListener("click", toggleFlip);
    function toggleFlip() {
      var panel = document.querySelector(".archive_news_type .panel");
      if (panel.style.display === "flex") {
        panel.style.display = "none";
        archive.classList.remove("flip_toggle");
      } else {
        archive.classList.add("flip_toggle");
        panel.style.display = "flex";
      }
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF ARCHIVE ICONS *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* RESPONSIVE TABLE *.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      document.querySelector(".ck_editor").replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* RESPONSIVE TABLE *.*.*.*.*.*.*.*.*.*.*
})
